import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CentrosCostoDto } from '../models/centros-costo.dto';

@Injectable({
  providedIn: 'root'
})
export class CentrosCostoService {

  private apiUrl = ``;
  private entity = `centros-costo`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }


  getAll(): Observable<CentrosCostoDto[]> {
    return this.http.get<CentrosCostoDto[]>(this.apiUrl);
  }

}
